import {
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
  GridColumnMenuSort,
} from "@progress/kendo-react-grid";
import React from "react";

export const TaskGridFilter = (props, data, setData) => {
  return (
    <>
      {!(
        props.column.field.includes("Date") ||
        props.column.field.includes("Due") ||
        props.column.field.includes("Start")
      ) ? (
        <GridColumnMenuCheckboxFilter
          {...props}
          data={data.data}
          expanded={true}
        />
      ) : (
        <GridColumnMenuFilter {...props} data={data} expanded={true} />
      )}
      <GridColumnMenuSort {...props} />
    </>
  );
};
